var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChatBubble = function SvgChatBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.975.462A17.496 17.496 0 0 0 2.917 26.895l-.85 6.804a1.593 1.593 0 0 0 1.965 1.742l6.497-1.624a17.288 17.288 0 0 0 7.446 1.672c9.673 0 17.514-7.841 17.514-17.514 0-9.672-7.841-17.513-17.514-17.513z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgChatBubble;